import { SearchResponseSchema, type SearchResponse } from '@aroo/shared';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { apiGet } from './client';

/** GET /search?q=: people, sites and vehicles the signed-in person may open (two characters+). */
export function useGlobalSearch(q: string) {
  const term = q.trim();
  return useQuery<SearchResponse>({
    queryKey: ['search', term],
    queryFn: () => apiGet('/search', SearchResponseSchema, { q: term }),
    enabled: term.length >= 2,
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  });
}
